import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './styles/global.scss'
import { installImageAuthGuard } from '@/utils/sessionGuard'
import { installChunkErrorGuard, consumeChunkErrorReturnTo } from '@/utils/chunkErrorGuard'
import { initTokenKeepAlive } from '@/api/request'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus, { locale: zhCn })

app.mount('#app')

// 受保护图片（/uploads 非公开目录）加载失败的全局恢复：重发 img_token cookie 或弹重新登录框
installImageAuthGuard()
// 部署切换后旧 chunk 404 的兜底：动态 import 失败自动刷新拉新版本，防"点了没反应"
installChunkErrorGuard(() => router.currentRoute.value.fullPath)
// chunk 404 兜底刷新后自动回到用户刚才所在页面
const chunkReturnTo = consumeChunkErrorReturnTo()
if (chunkReturnTo) router.replace(chunkReturnTo)
// 长时间挂后台/锁屏后回前台时主动刷新临期 token，避免用户点击时撞上过期 401 链路（点了没反应的体感）
initTokenKeepAlive()
